import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());

    const InitialData = {
        gateway_name: "",
        marchant_id: "",
        marchant_username: "",
        key1: "",
        key2: "",
        key3: "",
        key4: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/gateway/fetchSingle", {...filter, user: store_data});
        const GatewayData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: GatewayData["id"],
                gateway_name: GatewayData["gateway_name"],
                marchant_id: GatewayData["marchant_id"],
                marchant_username: GatewayData["marchant_username"],
                key1: GatewayData["key1"],
                key2: GatewayData["key2"],
                key3: GatewayData["key3"],
                key4: GatewayData["key4"],
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        setLoading(false)
        if(is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) {
            return;
        }
        // console.log(FormData)
        const payload = { org_id: store_data?.org_id, ...FormData }
        const response = await postAPI(is_edit ? "/gateway/update" : "/gateway/create", {...payload, user: store_data});
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('New Gateway Credential Added Successfully.');
            window.location.reload();
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {
                Loading ?
                    <Loader />
                    :
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div class="col-12 col-md-12 mt-0">
                            {/* <SelectBoxHandler Label="Gateway" Options={[{ "label": "Stripe", "value": "STRIPE" }, { "label": "Razorpay", "value": "RAZORPAY" }, { "label": "Cash", "value": "COD" }]} Name="gateway_name" setFormData={setFormData} form_data={FormData} MultiSelection={false} /> */}
                            <SelectBoxHandler Label="Gateway" Options={[{ "label": "Bypass", "value": "BYPASS" }, { "label": "Cashfree", "value": "CASHFREE" }]} Name="gateway_name" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="marchant_id" Type="text" Label="Marchant ID" />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="marchant_username" Type="text" Label="Marchant Username" />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="key1" Type="text" Label="Key 1" />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="key2" Type="text" Label="key 2" />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="key3" Type="text" Label="key 3" />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="key4" Type="text" Label="key 4" />
                        </div>
                    </FormSubmissionHandler>
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
